import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Grid } from '@mui/material';

const UpdatePasswordDialog = ({ open, onClose, onSubmit, username }) => {
    const [password, setPassword] = useState('');

    React.useEffect(() => {
        setPassword('');
    }, [open]);

    const handleSubmit = () => {
        onSubmit(username, password);
        onClose();
    };

    const isValid = password.length >= 8;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Aggiorna password di {username}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{ minWidth: '350px', pt: 1 }}>
                    <Grid item xs={12}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Nuova password (min 8 caratteri)"
                            type="password"
                            fullWidth
                            variant="outlined"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit} color="primary" disabled={!isValid}>
                    OK
                </Button>
                <Button onClick={onClose} color="secondary">
                    Annulla
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UpdatePasswordDialog;
